import { FlexSectionController } from "../../models/flexible/flex-section-controller";
import { combinePaths, isSectionEmbedded } from "../../models/flexible/utils";
import { DesignedSection } from "./DesignedSection";
import { DynamicSection } from "./DynamicSection";

export interface ISectionProps {
	controller: FlexSectionController;
	parentPath: string;
	canCopy?: boolean;
	canDelete?: boolean;
	initialIndex?: number;
	handleCopy?: () => void;
	handleDelete?: () => void;
}

export interface ISectionRenderProps extends ISectionProps {
	sectionPath: string;
}

export const SectionRoot: React.FC<ISectionProps> = (props) => {
	const { parentPath: path, controller } = props;
	const sectionPath = isSectionEmbedded(controller.schema) ? path : combinePaths(path, controller.schema.localizableKey);
	const isDynamicSections = controller.context.isNegotiable && controller.schema.isHeaderShown && !controller.parent;
	const isSectionHidden = controller.useIsSectionHidden ? controller.useIsSectionHidden() : false;

	if (isSectionHidden) {
		return null;
	}

	return isDynamicSections ? (
		<DynamicSection {...props} sectionPath={sectionPath} />
	) : (
		<DesignedSection {...props} sectionPath={sectionPath} />
	);
};
